// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1IPhT","label":"SetPasswdForm_label__1gMM5"};